'use client';

import { useScrollTarget } from '@coolblue-development/freddy';
import type { ReactNode, Ref } from 'react';
import { createContext } from 'react';

type OrderBlockContextProviderProps = {
  children: ReactNode;
  isCustomerFacingEmployee?: boolean;
};

type OrderBlockContextValue = {
  scrollTargetRefMainInformation?: Ref<HTMLDivElement>;
  scrollTargetRefOrderSummary?: Ref<HTMLDivElement>;
  isWithinScrollTargetMainInformation?: boolean;
  isWithinScrollTargetOrderSummary?: boolean;
  isCustomerFacingEmployee?: boolean;
};

export const OrderBlockContext = createContext<OrderBlockContextValue>({});

export const OrderBlockContextProvider = ({
  children,
  isCustomerFacingEmployee = false
}: OrderBlockContextProviderProps) => {
  const {
    scrollTargetRef: scrollTargetRefMainInformation,
    isWithinScrollTarget: isWithinScrollTargetMainInformation
  } = useScrollTarget(entry => !entry.isIntersecting, {
    rootMargin: '-52px'
  });

  const {
    scrollTargetRef: scrollTargetRefOrderSummary,
    isWithinScrollTarget: isWithinScrollTargetOrderSummary
  } = useScrollTarget(entry => entry.boundingClientRect.top < 0 || entry.isIntersecting, {
    rootMargin: '-52px'
  });

  return (
    <OrderBlockContext.Provider
      value={{
        scrollTargetRefMainInformation,
        scrollTargetRefOrderSummary,
        isWithinScrollTargetMainInformation,
        isWithinScrollTargetOrderSummary,
        isCustomerFacingEmployee
      }}
    >
      {children}
    </OrderBlockContext.Provider>
  );
};
